export default {
  API_URL: process.env.API_BASE_URL || process.env.REACT_APP_API_BASE_URL,
  SERVICING_URL: process.env.SERVICING_URL || process.env.REACT_APP_SERVICING_URL,
  GENERAL_CONDITION_BASE_URL: process.env.GENERAL_CONDITION_BASE_URL || process.env.REACT_APP_GENERAL_CONDITION_BASE_URL,
  CLIENT_BASIC_AUTH: 'sellerwebapp:z5wmY8NM',
  IUBENDA_API_KEY: process.env.IUBENDA_API_KEY || process.env.REACT_APP_IUBENDA_API_KEY,
  POLICY_BASE_URL: process.env.POLICY_BASE_URL || process.env.REACT_APP_POLICY_BASE_URL,
  SLIMPAY_WS_URL: process.env.SLIMPAY_WS_URL || process.env.REACT_APP_SLIMPAY_WS_URL
};



// WEBPACK FOOTER //
// ./src/services/constants.js